<!--
	Clone dari McrFooter.vue (file lama dibiarkan sebagai history), dipakai New_McrForm.vue.
	Bedanya: Save cataloguer (saveCatalog) memakai aturan form engine FORM02 -- validasi & payload dibaca dari
	config (cataloguerFormConfig.js), bukan aturan hardcode helperMcrFooter. Lihat DECISIONS_LOG.md
	"Save Cataloguer FORM02".
-->
<template>
	<div class="p-0 m-0">
		<ToastPrime position="bottom-left"/>
		<div class="row mt-1">
			<div class="col-12 d-flex align-items-center justify-content-center" style="gap: 10px;">
				<!-- Draft path: Back to Draft / Save to Draft + Send -->
				<button v-if="showSaveDraftButton" type="button" class="btn btn-sm btn-primary" :disabled="isLoadingSaveDraft || isLoadingCreate || isLoadingSaveDraftStay" @click="saveDraft">
					<span v-if="isLoadingSaveDraft"><i class="fas fa-spinner fa-spin me-2"></i>Please wait</span>
					<span v-else><i :class="isDraftStatus ? 'fas fa-list me-2' : 'fas fa-save me-2'"></i>{{ saveDraftLabel }}</span>
				</button>
				<button v-if="showSendButton" type="button" class="btn btn-sm btn-success" :disabled="isLoadingSaveDraft || isLoadingCreate || isLoadingSaveDraftStay || !hasMcrItems" @click="send()">
					<span v-if="isLoadingCreate"><i class="fas fa-spinner fa-spin me-2"></i>Please wait</span>
					<span v-else><i class="fas fa-paper-plane me-2"></i>Send</span>
				</button>
				<!-- My Task path (Cataloguer): Reject + Send Back + Approve + Save -->
				<button v-if="showRejectButton" type="button" class="btn btn-sm btn-danger" :disabled="isLoadingSendBack || isLoadingApprove || isLoadingReject" data-bs-toggle="modal" data-bs-target="#modalFooterMcr" @click="openFooterModal('reject')">
					<span v-if="isLoadingReject"><i class="fas fa-spinner fa-spin me-2"></i>Please wait</span>
					<span v-else><i class="fas fa-times me-2"></i>Reject</span>
				</button>
				<button v-if="showSendBackButton" type="button" class="btn btn-sm btn-warning text-white" :disabled="isLoadingSendBack || isLoadingApprove || isLoadingReject" data-bs-toggle="modal" data-bs-target="#modalFooterMcr" @click="openFooterModal('sendBack')">
					<span v-if="isLoadingSendBack"><i class="fas fa-spinner fa-spin me-2"></i>Please wait</span>
					<span v-else><i class="fas fa-undo me-2"></i>Send Back</span>
				</button>
				<button v-if="showApproveButton" type="button" class="btn btn-sm btn-success" :disabled="isLoadingSendBack || isLoadingApprove || isLoadingReject" @click="openFooterModal('approve')">
					<span v-if="isLoadingApprove"><i class="fas fa-spinner fa-spin me-2"></i>Please wait</span>
					<span v-else><i class="fas fa-check me-2"></i>Approve</span>
				</button>
				<!--isSpecialType = 'flag-unflag', 'block-unblock', 'mrp', 'update-price', 'mass-update-mrp' -->
				<button v-if="showSaveDraftStayButton" type="button" class="btn btn-sm btn-secondary" :disabled="isLoadingSaveDraft || isLoadingCreate || isLoadingSaveDraftStay" @click="saveDraftStay">
					<span v-if="isLoadingSaveDraftStay"><i class="fas fa-spinner fa-spin me-2"></i>Please wait</span>
					<span v-else><i class="fas fa-save me-2"></i>Save Draft</span>
				</button>
				<button v-if="showSaveDraftAntamButton" type="button" class="btn btn-sm btn-secondary" :disabled="isLoadingSaveDraftFormUserAntam || !selectedMcrItem || isLoadingSaveDraft || isLoadingApprove || isLoadingReject || isLoadingSendBack" @click="saveDraftPeritemFormUserAntam">
					<span v-if="isLoadingSaveDraftFormUserAntam"><i class="fas fa-spinner fa-spin me-2"></i>Please wait</span>
					<span v-else><i class="fas fa-save me-2"></i>Save</span>
				</button>
				<button v-if="showSaveButtonForCataloguer" type="button" class="btn btn-sm btn-primary" :disabled="!selectedMcrItem || isLoadingSaveDraft || isLoadingApprove || isLoadingReject || isLoadingSendBack" @click="saveCatalog">
					<span v-if="isLoadingSaveDraft"><i class="fas fa-spinner fa-spin me-2"></i>Please wait</span>
					<span v-else><i class="fas fa-save me-2"></i>Save</span>
				</button>
			</div>
		</div>
	</div>

	<!-- Modal Footer (Reject / Send Back / Approve) -->
	<div id="modalFooterMcr" class="modal fade" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">{{ modalFooter.title }}</h5>
				</div>
				<div class="modal-body">
					<!-- ANTAM, role Material Management Cataloguer / Managerial: tujuan Send Back dipilih dari opsi step workflow
					     (get-step data.options), dikirim sebagai `step_send_back`. -->
					<div v-if="modalFooter.action === 'sendBack' && canChooseSendBackStep" class="mb-3">
						<label class="form-label">Send Back to <span class="text-danger">*</span></label>
						<SelectPrime v-model="modalFooter.sendBackTo" :options="modalFooter.sendBackOptions" option-label="description"
							:loading="modalFooter.sendBackLoading" placeholder="Select send back destination" size="small" fluid append-to="self"
							:invalid="!!modalFooter.errorMessage['sendBackTo'] && !modalFooter.sendBackTo" />
						<div v-if="modalFooter.errorMessage['sendBackTo'] && !modalFooter.sendBackTo" class="text-danger text-sm">
							{{ modalFooter.errorMessage['sendBackTo'] }}
						</div>
					</div>
					<div class="mb-3">
						<label class="form-label">Note <span v-if="['sendBack', 'reject'].includes(modalFooter.action)" class="text-danger">*</span></label>
						<textarea v-model="modalFooter.note" class="form-control" placeholder="Write the note" rows="4"
							:class="modalFooter.errorMessage['note'] && !modalFooter.note ? 'border-danger' : ''"></textarea>
						<div v-if="modalFooter.errorMessage['note'] && !modalFooter.note" class="text-danger text-sm">
							{{ modalFooter.errorMessage['note'] }}
						</div>
					</div>
					<template v-if="requiresSapCredentials && modalFooter.action == 'approve'">
						<div class="mb-3">
							<label class="form-label">Username SAP <span class="text-danger">*</span></label>
							<InputText v-model="modalFooter.username" placeholder="Enter SAP Username" size="small" fluid />
						</div>
						<div class="mb-3">
							<label class="form-label">Password SAP <span class="text-danger">*</span></label>
							<Password v-model="modalFooter.password" placeholder="Enter SAP Password" :toggleMask="true" size="small" :feedback="false" fluid />
						</div>
					</template>
				</div>
				<div class="modal-footer">
					<button ref="closeModalFooterMcr" type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModal">Close</button>
					<button type="button" class="btn btn-primary text-white" :disabled="isModalActionDisabled || isLoadingSendBack || isLoadingReject || isLoadingApprove" @click="modalAction">
						<span v-if="isLoadingSendBack || isLoadingReject || isLoadingApprove">
							<i class="fas fa-spinner fa-spin"></i>&nbsp;Please wait
						</span>
						<span v-else>{{ modalFooter.action === 'sendBack' ? 'Send Back' : modalFooter.action === 'reject' ? 'Reject' : 'Approve' }}</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import bootstrap from "bootstrap/dist/js/bootstrap.min.js";
import api from "@/helpers/api";
import cataloguerFormService from '@/services/materialCatalogingRequest/cataloguerFormService';
import flagUnflagFormService from '@/services/materialCatalogingRequest/flagUnflagFormService';
import blockUnblockFormService from '@/services/materialCatalogingRequest/blockUnblockFormService';
import mrpFormService from '@/services/materialCatalogingRequest/mrpFormService';
import massUpdateMrpFormService from '@/services/materialCatalogingRequest/massUpdateMrpFormService';
import extendFormService from '@/services/materialCatalogingRequest/extendFormService';
import woApprovalService from '@/services/dashboards/woApprovalService';
import { buildDynamicRulesForItem, validateMcrItemCore } from '@/views/materialCatalogRequest/modules/cataloguer/helperMcrFooter';
import { CATALOGUER_TAB_LIST } from '@/views/materialCatalogRequest/modules/cataloguer/cataloguerFormConfig';
import formConfig from '@/helpers/New_formConfig';
import userFormService from '@/services/materialCatalogingRequest/userFormService';
import manageAccountService from '@/services/manageAccount/manageAccountService';

const REQUIRED_MESSAGE = 'This field is required.';

// Value select bisa tersimpan sebagai object opsi ({ value/code, label }) -- yang dikirim cuma kodenya.
const toPayloadValue = (val) => {
	if (val instanceof Date) return formConfig.formatDate(val);
	if (val && typeof val === 'object' && !Array.isArray(val)) return val.code ?? val.value ?? null;
	return val === undefined ? null : val;
};

export default {
	data() {
		return {
			clientCode: '',
			companyCode: '',
			technicalReviewerOptionsPromise: null,
			isLoadingSaveDraft: false,
			isLoadingSaveDraftStay: false,
			isLoadingCreate: false,
			isLoadingSendBack: false,
			isLoadingReject: false,
			isLoadingApprove: false,
			isLoadingSaveDraftFormUserAntam: false,
			modalFooter: {
				title: "",
				note: "",
				errorMessage: [],
				action: null,
				username: "",
				password: "",
				// Send Back ANTAM (canChooseSendBackStep): opsi get-step & opsi yang dipilih (objek opsi utuh).
				sendBackOptions: [],
				sendBackTo: null,
				sendBackLoading: false,
			}
		}
	},
	computed: {
		// form_code aktif = getter mcr/getFormCode (setting mcr_form_type: mcr_type + status header), sama dengan New_McrItem.
		formCode() {
			return this.$store.getters['mcr/getFormCode']?.form_code || null;
		},
		...mapState({
			authUserPermissions: (state) => state.auth.userHasPermissions || {},
      stateAllMcrItemCat: (state) => state.mcr.allMcrItem || [],
      mcrHeader: (state) => state.mcr.mcrHeader || {},
      selectedMcrItem: (state) => state.mcr.selectedMcrItem,
      mapHardcodeMcr: (state) => state.mcr.mapHardcodeMcr || {},
			cataloguingFormConfig: (state) => state.mcr.cataloguingFormConfig,
			// Form engine (New_McrForm -> mcr/fetchFormConfig): config hasil resolve BE.
			engineFormConfig: (state) => state.mcr.mcrDetail?.formConfig || null,
      userHasRoles: (state) => state.auth.userHasRoles || [],
		}),
		mcrType() {
			const raw = (this.mcrHeader?.type || '').toLowerCase().replace(/\s+/g, '-');
			// mcrHeader.type bisa berupa kode (MCR003) atau slug (extend). Normalisasi kode → slug.
			const codeToSlug = {
				mcr001: 'create-new',
				mcr002: 'change-material',
				mcr003: 'extend',
				mcr004: 'block-unblock',
				mcr005: 'flag-unflag',
				mcr006: 'consolidation',
				mcr007: 'mass-update-mrp',
				mcr010: 'change-master-data',
			};
			return codeToSlug[raw] || raw;
		},
		isSpecialType() {
			return ['flag-unflag', 'block-unblock', 'mrp', 'update-price', 'mass-update-mrp', 'change-master-data', 'consolidation'].includes(this.mcrType);
		},
		saveDraftLabel() {
			// Status 'draft' → "Back to Draft" (UserForm)
			// Status lain → "Save to Draft" (CataloguerForm)
			return this.mcrHeader.status === 'draft' ? 'Back to Draft' : 'Save to Draft';
		},
		isDraftStatus() {
			return ['draft', 'send_back'].includes(this.mcrHeader.status);
		},	
		isFromMyTask() {
			return this.$route.path.includes('my-task');
		},
		isFromEditSyncTask() {
			return this.$route.path.includes('edit-sync-task');
		},
		workflowReceivers() {
			return this.mcrHeader?.wc_workflow?.current_step?.data?.receivers || [];
		},
		// Username & Password SAP di modal Approve: cuma di step workflow ANTAM "Approval Material Management Cataloguer 2"
		// yang penerimanya role Material Management Cataloguer.
		requiresSapCredentials() {
			const receivers = this.workflowReceivers;
			const isAntamCompany = receivers.some(r => r.to === 'company' && r.values?.includes('ANTAM'));
			const isMaterialMgmtCataloguer = receivers.some(r => r.to === 'role' && r.values?.includes('Material Management Cataloguer'));
			const isSapStep = this.mcrHeader?.wc_workflow?.current_step?.description === 'Approval Material Management Cataloguer 2';
			return isAntamCompany && isMaterialMgmtCataloguer && isSapStep;
		},
		isAntamCompanyOrClient() {
			return this.companyCode === 'ANTAM' || this.clientCode === 'ANTAM';
		},
		// ANTAM, role Material Management Cataloguer / Managerial (semua MCR type): Send Back memilih tujuan step workflow.
		canChooseSendBackStep() {
			const roles = ['Material Management Cataloguer', 'Material Management Managerial'];
			return this.isAntamCompanyOrClient && this.userRoleNames.some((role) => roles.includes(role));
		},
		isModalActionDisabled() {
			if (this.modalFooter.action === 'sendBack' && this.canChooseSendBackStep && !this.modalFooter.sendBackTo) return true;
			if (['sendBack', 'reject'].includes(this.modalFooter.action)) return !this.modalFooter.note;
			if (this.requiresSapCredentials) return !this.modalFooter.username || !this.modalFooter.password;
			return false;
		},
		// Indikator apakah MCR sudah punya minimal 1 item. Baca dari form yang sedang
		// dirender (paling akurat & reaktif): special form → cek baris terisi (form selalu
		// menyiapkan 1 baris kosong, jadi rows.length saja tidak cukup); UserForm → cek
		// items lokal (store bisa stale setelah item ditambah); fallback → store allMcrItem.
		hasMcrItems() {
			const form = this.activeFormRef();
			if (form && Array.isArray(form.rows)) {
				return form.rows.some(r => r && (r.id || r.mcr_item_code || r.material_number));
			}
			if (form && Array.isArray(form.items)) {
				return form.items.length > 0;
			}
			return (this.stateAllMcrItemCat || []).length > 0;
		},
		showSaveDraftButton() {
			return !this.isFromMyTask && !this.isFromEditSyncTask;
		},
		showSaveDraftStayButton() {
			// Semua special type termasuk MCR007 (mass-update-mrp) menampilkan tombol 'Save Draft'
			// untuk menyimpan progres draft tanpa memulai workflow -- juga dari Edit Sync Task.
			return this.isFormEditable && this.isSpecialType;
		},
		showSendButton() {
			// Send hanya muncul kalau MCR sudah punya minimal 1 item (belum ada item → tombol disembunyikan)
			return !this.isFromMyTask && !this.isFromEditSyncTask;
		},
		// Form MCR boleh diedit (meta.formMode route + mcr_form_access) -- sumber yang sama dengan readonly form di New_McrItem.
		isFormEditable() {
			return this.$store.getters['mcr/isFormEditable'];
		},
		// Simpan draft (form Cataloguer FORM02 saat MCR masih draft, mis. User / Inventory Control ANTAM): siapa yang boleh =
		// mcr_form_access 'edit' untuk status draft, bukan daftar role di sini.
		showSaveDraftAntamButton() {
			return this.isFormEditable && this.formCode === 'FORM02' && this.isDraftStatus;
		},
		workflowResult() {
			return this.mcrHeader?.wc_workflow?.current_step?.data?.result || {};
		},
		userRoleNames() {
			return this.userHasRoles.map(role => (typeof role === 'string' ? role : role.name));
		},
		hasWorkflowRoleReceiver() {
			return this.workflowReceivers.some(r => r.to === 'role' && r.values?.some(v => this.userRoleNames.includes(v)));
		},
		showRejectButton() {
			return this.isFromMyTask && 'reject' in this.workflowResult && this.hasWorkflowRoleReceiver;
		},
		showSendBackButton() {
			return this.isFromMyTask && 'send_back' in this.workflowResult && this.hasWorkflowRoleReceiver;
		},
		showApproveButton() {
			return this.isFromMyTask && 'approve' in this.workflowResult && this.hasWorkflowRoleReceiver;
		},			
		// Save di sini selalu pakai aturan FORM02 -> cuma tampil kalau form yang dirender memang FORM02
		// (New_CataloguerForm). Cataloguer di MCR004-009 dapat form lain (FORM03/04/05/06/01) lewat role "Other".
		// Siapa yang boleh = mcr_form_access 'edit' (bukan daftar role di sini). MCR draft memakai Save Draft (endpoint draft:
		// status item tetap, PO text tidak di-generate), jadi Save Cataloguer tidak ditampilkan bersamaan.
		showSaveButtonForCataloguer() {
			return (this.isFromMyTask || this.isFromEditSyncTask) && this.isFormEditable && this.formCode === 'FORM02'
				&& !this.isDraftStatus;
		},
	},
	mounted() {
		const userAuth = JSON.parse(localStorage.getItem('userAuth') || '{}');
		this.clientCode = userAuth?.user?.client_code || '';
		this.companyCode = userAuth?.user?.company_code || '';
		this.maybePrefetchTechnicalReviewerOptions();
	},
	watch: {
		// McrForm (parent) fetch mcrHeader secara async di mounted()-nya sendiri. Watch ini yang re-cek begitu
		// mcrHeader benar-benar sudah keisi (mcr.js commit object baru tiap kali fetch selesai).
		mcrHeader() {
			this.maybePrefetchTechnicalReviewerOptions();
		},
	},
	methods: {
		maybePrefetchTechnicalReviewerOptions() {
			// Guard `technicalReviewerOptionsPromise` supaya cuma fetch sekali walau dipanggil dari
			// mounted() maupun watch(mcrHeader) di atas.
			if (this.technicalReviewerOptionsPromise) return;
			if (this.showSendButton && this.isDraftStatus && !this.isSpecialType && this.companyCode === 'TIMAH') {
				this.technicalReviewerOptionsPromise = this.fetchTechnicalReviewerOptions();
			}
		},
		...mapActions("mcr", ["addValidationErrorAllMcrItemCat", "deleteErrorValidationAllMcrItemCat", "triggerRefresh", "storeAllMcrItem"]),
		async fetchTechnicalReviewerOptions() {
			try {
				const reviewerRes = await api(this, manageAccountService.list({ company_code: this.companyCode, role: "Technical Team" }), false);
				const reviewerList = reviewerRes?.data?.data || reviewerRes?.data || [];
				return (Array.isArray(reviewerList) ? reviewerList : []).reduce((acc, u) => {
					acc[u.username] = u.name ? `${u.username} - ${u.name}` : u.username;
					return acc;
				}, {});
			} catch (error) {
				return {};
			}
		},
		// Form yang sedang dirender (special form / UserForm), di layout mana pun:
		// - layout lama (McrForm): ref-nya langsung di parent → $refs.specialForm / $refs.userForm
		// - layout baru (New_McrForm → McrItem): form-nya ada di dalam McrItem, jadi diambil
		//   lewat activeForm() milik komponen itu.
		// Sengaja method (bukan computed): $refs tidak reaktif, computed-nya bisa nyangkut null.
		activeFormRef() {
			const parent = this.$parent;
			const direct = parent?.$refs?.specialForm || parent?.$refs?.userForm;
			if (direct) return direct;
			return parent?.$refs?.mcrItem?.activeForm?.() || null;
		},
		getSpecialFormService() {
			if (this.mcrType === 'flag-unflag') return flagUnflagFormService;
			if (this.mcrType === 'block-unblock') return blockUnblockFormService;
			if (this.mcrType === 'mrp') return mrpFormService;
			if (this.mcrType === 'mass-update-mrp') return massUpdateMrpFormService;
			if (this.mcrType === 'extend') return extendFormService;
			// MCR010 (change master data) & MCR006 (consolidation) memakai endpoint block-unblock:
			// BE memilih form config dari type MCR (FORM03 / FORM08 / FORM07), payload-nya
			// sama-sama `items[]`.
			if (this.mcrType === 'change-master-data') return blockUnblockFormService;
			if (this.mcrType === 'consolidation') return blockUnblockFormService;
			return null;
		},
		async saveSpecialForm() {
			const form = this.activeFormRef();
			// MASS UPDATE MRP: validasi dilakukan BE (rules dari form config yang sama), FE cukup
			// mengirim payload & menampilkan error per baris dari response. Jangan blokir di FE,
			// kalau tidak response validasi BE tidak pernah tampil.
			// Form special lainnya tetap validasi di FE seperti sebelumnya.
			const validateOnBe = this.mcrType === 'mass-update-mrp';
			const isValid = validateOnBe
				? true
				: (form?.validate ? form.validate() : (this.$parent?.validateSpecialForm?.() ?? true));
			if (!isValid) {
				this.$toastNotifPrime('warn', 'Validation', 'Please complete all required fields.');
				return false;
			}
			const service = this.getSpecialFormService();
			if (!service) {
				this.$toastNotifPrime('error', 'Error', `Save service for ${this.mcrType} is not registered.`);
				return false;
			}
			const id = this.$route.params.id;
			const params = { items: form?.getPayload ? form.getPayload() : (form?.rows ?? this.stateAllMcrItemCat) };
			// Save Draft & Send sama-sama memakai endpoint save yang lama.
			const response = await api(this, service.save(id, params), false);

			// Kontrak response disamakan dengan ImportExcelModal: validasi bisa datang sebagai
			// HTTP 200 dengan body { status: 'error', data: [{ row, field, value, error }] }.
			// `api` mengembalikan body apa adanya (kadang dibungkus `data`), jadi cek keduanya.
			const errorBody = [response, response?.data].find(
				body => body && typeof body === 'object' && !Array.isArray(body) && body.status === 'error'
			);
			if (errorBody) {
				this.showLineValidationErrors(errorBody.data, errorBody.message);
				return false;
			}
			return true;
		},
		// Tampilkan error validasi per baris dengan bentuk yang sama seperti tabel error import
		// ({ row, field, value, error }) — dipakai Save Draft & error response lainnya.
		showLineValidationErrors(data, message = 'Validation failed') {
			// `data` bisa berupa array baris error ({ row, field, error }) atau mapping
			// field -> pesan (format Laravel). Keduanya ditampilkan dengan bentuk yang sama.
			const items = Array.isArray(data)
				? data
				: (data && typeof data === 'object'
					? Object.entries(data).map(([field, value]) => ({ field, error: Array.isArray(value) ? value.join(', ') : value }))
					: [data]);
			const lines = items
				.filter(Boolean)
				.map(item => {
					if (typeof item !== 'object') return `• ${item}`;
					// row 0 (error level file/sheet, mis. dari import) sengaja tanpa prefix nomor baris.
					const row = item.row > 0 ? `Row ${item.row}` : null;
					const field = item.field ? (item.row ? `(${item.field})` : item.field) : null;
					const prefix = [row, field].filter(Boolean).join(' ');
					const text = item.error ?? item.message ?? item.value ?? 'Invalid value';
					return `• ${prefix ? `${prefix}: ` : ''}${text}`;
				});
			if (!lines.length) return;
			this.$toastNotifPrime('error', message || 'Validation failed', lines.join('\n'));
		},
		async saveDraft() {
			// Jika status draft (UserForm) → redirect ke list tanpa save
			if (this.isDraftStatus) {
				this.$router.push({ name: "Draft List" });
				return;
			}

			// Special types ('flag-unflag', 'block-unblock', 'mrp', 'extend', 'update-price') bypass cataloguer validation
			if (this.isSpecialType) {
				this.isLoadingSaveDraft = true;
				try {
					const saved = await this.saveSpecialForm();
					if (!saved) return;
					this.$router.push({ name: "Draft List" });
				} catch (error) {
					this.handleErrorObjectNested(error);
				} finally {
					this.isLoadingSaveDraft = false;
				}
				return;
			}

			setTimeout(() => { this.$router.push({ name: "Draft List" }) }, 500);
    },
		async saveDraftStay() {
			// Jika status draft (UserForm) → save special items only (no workflow start)
			if (this.isDraftStatus) {
				this.isLoadingSaveDraftStay = true;
				try {
					if (this.isSpecialType) {
						const saved = await this.saveSpecialForm();
						if (!saved) return;
					}
					this.$toastNotifPrime('success', 'Success', 'Draft saved successfully');
					this.triggerRefresh();
				} catch (error) {
					this.handleErrorObjectNested(error);
				} finally {
					this.isLoadingSaveDraftStay = false;
				}
				return;
			}

			// Special types bypass cataloguer validation
			if (this.isSpecialType) {
				this.isLoadingSaveDraftStay = true;
				try {
					const saved = await this.saveSpecialForm();
					if (!saved) return;
					this.$toastNotifPrime('success', 'Success', 'Draft saved successfully');
					this.triggerRefresh();
				} catch (error) {
					this.handleErrorObjectNested(error);
				} finally {
					this.isLoadingSaveDraftStay = false;
				}
				return;
			}

			// Jika status lain (CataloguerForm) → save draft
			this.deleteErrorValidationAllMcrItemCat();
			this.isLoadingSaveDraftStay = true;

			const type = "processed";
			const { validation, message } = this.validateAllTabsCatalogForm(type);
			if (!validation) {
				this.isLoadingSaveDraftStay = false;
				const tabs = message.split(',').map(tab => tab.trim());
				const tabsList = tabs.map(tab => `
					<div style="
						background: white;
						color: #2d3748;
						padding: 8px 14px;
						margin: 6px 0;
						border-radius: 6px;
						font-weight: 500;
						font-size: 0.85rem;
						border: 1px solid #e2e8f0; box-shadow: 0 1px 3px rgba(0,0,0,0.08);
						display: flex;
						align-items: center;
						gap: 6px;
					">
						<i class="pi pi-exclamation-circle" style="font-size: 0.85rem; color: #dc3545;"></i>
						<span>${tab}</span>
					</div>
				`).join('');

				this.$swal({
					icon: 'error',
					title: '<span style="font-size: 1.2rem; font-weight: 600; color: #2d3748; margin-top: -10px; display: block;">Validation Required</span>',
					html: `
						<div style="text-align: left; padding: 0 10px;">
							<p style="color: #4a5568; margin-bottom: 8px; font-size: 0.85rem;">Please complete the following tabs:</p>
							${tabsList}
						</div>
					`,
					confirmButtonText: '<i class="pi pi-check-circle"></i> Got It!',
					confirmButtonColor: '#667eea',
					padding: '0.5rem 1.5rem 1.5rem',
					backdrop: 'rgba(0,0,0,0.4)',
					customClass: {
						popup: 'swal-modern-popup',
						title: 'swal-modern-title',
						htmlContainer: 'swal-modern-html'
					}
				});
				return;
			}

			const payloadCat = this.preparePayload("cataloguer");
			try {
				const id = this.$route.params.id;
				if (!id) {
					this.$toastNotifPrime('warn', 'Validation', 'MCR ID not found. Please save the MCR first.');
					return;
				}

				// const response = await api(this, cataloguerFormService.saveDraft(id, { emcr_items: payloadCat }), false);
				await api(this, cataloguerFormService.saveDraft(id, { emcr_items: payloadCat }), false);
				this.$toastNotifPrime('success', 'Success', 'Draft saved successfully');
				this.triggerRefresh();
			} catch (error) {
				this.handleErrorObjectNested(error);
			} finally {
				this.isLoadingSaveDraftStay = false;
			}
		},
    validateAttachments() {
			const isAntam = this.companyCode === 'ANTAM';
			const emptyRows = (this.stateAllMcrItemCat || [])
				.map((item, index) => {
					const isEmpty = isAntam ? !Array.isArray(item?.cat_emcr_item_attachment) || item.cat_emcr_item_attachment.length === 0 : Array.isArray(item?.emcr_item_attachment) && item.emcr_item_attachment.length === 0;
					return isEmpty ? index + 1 : null;
				})
				.filter((row) => row !== null);
			if (emptyRows.length > 0) {
				this.$toastNotifPrime(
					'error',
					'Validation',
					`Attachment is required. Row ${emptyRows.join(', ')} ${emptyRows.length > 1 ? 'do' : 'does'} not have any attachment yet.`
				);
				return false;
			}
			return true;
		},
    async send() {
			// Draft & non-draft (bukan special type) wajib punya minimal 1 attachment per item
			if (!this.isSpecialType && this.mcrType !== 'extend' && !this.validateAttachments()) return;

			// Jika status draft (UserForm) → start workflow
			if (this.isDraftStatus) {
				this.isLoadingCreate = true;
				try {
					// For special types, save items before starting workflow
					if (this.isSpecialType) {
						const saved = await this.saveSpecialForm();
						if (!saved) return;
					}

					// untuk dialog warning duplicate SPN saat akan send MCR
					if (!this.isSpecialType) {
						const duplRes = await api(this, userFormService.checkDuplSpnInUserForm(this.mcrHeader.mcr_code), false);
						const duplData = (duplRes && typeof duplRes === 'object' && duplRes.data && typeof duplRes.data === 'object') ? duplRes.data : duplRes;
						const duplicatedRows = Object.values(duplData || {}) .map((isDuplicate, idx) => (isDuplicate === true ? idx + 1 : null)) .filter((row) => row !== null);
						if (duplicatedRows.length > 0) {
							const confirmResult = await this.confirmDuplicateManufInUserForm(duplicatedRows);
							if (!confirmResult.isConfirmed) return;
						}
					}
					
					// untuk pilih user Technical Reviewer (khusus TIMAH) saat akan send MCR.
					let toUsername = null;
					if (!this.isSpecialType && this.companyCode === 'TIMAH') {
						const inputOptions = await (this.technicalReviewerOptionsPromise || this.fetchTechnicalReviewerOptions());

						const reviewerResult = await this.selectOptionDialog({
							title: "Choose User Technical Reviewer",
							inputOptions,
							inputPlaceholder: "Select a user",
							inputValidator: (value) => {
								if (!value) return "Please select a Technical Reviewer";
							},
						});
						if (!reviewerResult.isConfirmed) return;
						toUsername = reviewerResult.value;
					}

					const wfRes = await api(this, woApprovalService.getByModule('MCR'), false);
					const workflow_code = wfRes?.data?.code;
					if (!workflow_code) throw new Error('Workflow for MCR not found. Please contact administrator.');

					const payload = {
						code: workflow_code,
						key: this.mcrHeader.mcr_code,
						...(toUsername ? { to_username: toUsername } : {}),
					};
					// console.log("Sending MCR with payload:", payload);
					await api(this, woApprovalService.start(payload));
					this.$router.push({ name: "Draft List" });
				} catch (error) {
					this.$swal({
						icon: 'error',
						title: 'Error Sending MCR',
						text: error?.message || "Request failed with status code 500"
					});
				} finally {
					this.isLoadingCreate = false;
				}
				return;
			}

			// Special types bypass cataloguer validation
			if (this.isSpecialType) {
				this.isLoadingCreate = true;
				try {
					const saved = await this.saveSpecialForm();
					if (!saved) return;
					this.triggerRefresh();
				} catch (error) {
					this.handleErrorObjectNested(error);
				} finally {
					this.isLoadingCreate = false;
				}
				return;
			}

			// Non-draft, non-special type → open approve modal
			this.openFooterModal('approve');
    },
		// Dijalankan saat send MCR di Cataloguer/Managerial Cataloguer.
		validateItemsNotDraft() {
			const draftRows = (this.stateAllMcrItemCat || [])
				.map((item, index) => (item?.status === 'draft' ? index + 1 : null))
				.filter((row) => row !== null);
			if (draftRows.length > 0) {
				this.$toastNotifPrime(
					'error',
					'Validation',
					`MCR Item status must not be draft. Row ${draftRows.join(', ')} ${draftRows.length > 1 ? 'are' : 'is'} still in draft status.`
				);
				return false;
			}
			return true;
		},
    openFooterModal(type) {
			// Tipe khusus (Block/Unblock, Flag/Unflag, Mass Update, dst.) tidak punya attachment -- sama dengan send().
			if (type === 'approve' && !this.isSpecialType && this.workflowReceivers.some(r => r.to === 'role' && r.values?.includes('User')) && !this.validateAttachments()) {
				return;
			}
			// validateItemsNotDraft() cuma berlaku kalau (1) step workflow MCR ini memang step Cataloguer/Material Management Cataloguer, dan (2) user yang login juga punya salah satu role itu 
			const catalogerRoles = ['Cataloguer', 'Material Management Cataloguer'];
			const isCatalogerApprovalStep = this.workflowReceivers.some(r => r.to === 'role' && r.values?.some(v => catalogerRoles.includes(v)));
			const isCurrentUserCataloger = this.userHasRoles.some(role => catalogerRoles.includes(typeof role === 'string' ? role : role.name));
			if (type === 'approve' && isCatalogerApprovalStep && isCurrentUserCataloger && !this.validateItemsNotDraft()) {
				return;
			}
			this.modalFooter = {
				title: type === 'sendBack' ? 'Send Back' : type === 'reject' ? 'Reject' : 'Approve',
				action: type,
				note: '',
				errorMessage: [],
				username: '',
				password: '',
				sendBackOptions: [],
				sendBackTo: null,
				sendBackLoading: false,
			};
			if (type === 'sendBack' && this.canChooseSendBackStep) this.loadSendBackOptions();
			// 'approve' tidak lagi pakai data-bs-toggle di tombol (supaya modal tidak ikut terbuka kalau validateAttachments() atau this.validateItemsNotDraft() gagal di atas) — buka modal manual di sini.
			// 'sendBack'/'reject' tetap dibuka lewat data-bs-toggle di tombolnya masing-masing.
			if (type === 'approve') {
				this.$nextTick(() => {
					const modalEl = document.getElementById('modalFooterMcr');
					if (modalEl) {
						bootstrap.Modal.getOrCreateInstance(modalEl).show();
					}
				});
			}
		},
		closeModal() {
			this.modalFooter.note = '';
			this.modalFooter.errorMessage = [];
			this.modalFooter.username = '';
			this.modalFooter.password = '';
			this.modalFooter.sendBackOptions = [];
			this.modalFooter.sendBackTo = null;
			this.$refs.closeModalFooterMcr?.click();
		},
		// Opsi tujuan Send Back = data.options get-step (key = mcr_code); opsi `is_default` (= default_send_back) dipilih di awal.
		async loadSendBackOptions() {
			this.modalFooter.sendBackLoading = true;
			try {
				const response = await api(this, woApprovalService.getStep({ key: this.mcrHeader.mcr_code }), false);
				const data = response?.data || {};
				const options = Array.isArray(data.options) ? data.options : [];
				this.modalFooter.sendBackOptions = options;
				this.modalFooter.sendBackTo = options.find((option) => option.is_default)
					|| options.find((option) => option.value === data.default_send_back) || null;
			} catch (error) {
				this.modalFooter.sendBackOptions = [];
				this.modalFooter.sendBackTo = null;
				this.$toastNotifPrime('error', 'Error', 'Failed to load send back destinations');
			} finally {
				this.modalFooter.sendBackLoading = false;
			}
		},
		modalAction() {
			if (this.modalFooter.action === 'sendBack') {
				this.handleActionModal('isLoadingSendBack');
			} else if (this.modalFooter.action === 'reject') {
				this.handleActionModal('isLoadingReject');
			} else if (this.modalFooter.action === 'approve') {
				this.handleActionModal('isLoadingApprove');
			}
		},
		// Bangun teks "PS: ..." dari emcr_item_note tiap item di stateAllMcrItemCat (cancel/duplicate
		// yang masih pending, status === null) untuk disisipkan ke note approve/reject/sendBack.
		// Dibaca langsung dari store items (bukan dari state terpisah) supaya tetap akurat walau
		// halaman di-refresh.
		buildItemActionNotesText() {
			const cancelNotePrefix = 'This MCR Item has been canceled because';
			const uncancelNotePrefix = 'This MCR Item has been uncanceled because';
			const duplicateNotePrefix = 'This MCR Item has been marked as a duplicate because';
			const unDuplicateNotePrefix = 'This MCR Item has been unmarked as a duplicate because';
			const canceled = [];
			const duplicated = [];
			(this.stateAllMcrItemCat || []).forEach((item) => {
				const notes = item?.emcr_item_note;
				if (!Array.isArray(notes)) return;
				if (notes.some((n) => ((n.notes || '').startsWith(cancelNotePrefix) || (n.notes || '').startsWith(uncancelNotePrefix)) && n.status === null)) {
					canceled.push(item.mcr_item_code);
				}
				if (notes.some((n) => ((n.notes || '').startsWith(duplicateNotePrefix) || (n.notes || '').startsWith(unDuplicateNotePrefix)) && n.status === null)) {
					duplicated.push(item.mcr_item_code);
				}
			});
			const joinRows = (rows) => {
				if (rows.length === 0) return '';
				if (rows.length === 1) return `${rows[0]}`;
				if (rows.length === 2) return `${rows[0]} dan ${rows[1]}`;
				return `${rows.slice(0, -1).join(', ')}, dan ${rows[rows.length - 1]}`;
			};
			const lines = [];
			if (canceled.length > 0) {
				const rows = canceled.map((_, i) => i + 1);
				lines.push(`  - Telah melakukan status cancel di ${canceled.length} MCR Item, yaitu baris ke ${joinRows(rows)}`);
			}
			if (duplicated.length > 0) {
				const rows = duplicated.map((_, i) => i + 1);
				lines.push(`  - Telah melakukan status duplicated di ${duplicated.length} MCR Item, yaitu baris ke ${joinRows(rows)}`);
			}
			if (lines.length === 0) return '';
			return `Log: \n${lines.join('\n')}`;
		},
		async handleActionModal(loadingKey) {
			this[loadingKey] = true;
			try {
				await api(this, cataloguerFormService.saveNoteEmcr(this.mcrHeader.mcr_code, { action: 'update_status' }), false);
				const psText = this.buildItemActionNotesText();
				const note = psText ? `${this.modalFooter.note}${this.modalFooter.note ? '\n\n' : ''}${psText}` : this.modalFooter.note;
				const payload = {
					key: this.mcrHeader.mcr_code,
					note,
					// ...(loadingKey === 'isLoadingApprove' && this.isAntamCompanyOrClient && { force: 1 }),
					...(loadingKey === 'isLoadingApprove' && { force: 1 }),
					...(this.requiresSapCredentials && {
						username: this.modalFooter.username,
						password: this.modalFooter.password,
					}),
					// Tujuan Send Back yang dipilih (ANTAM, Material Management Cataloguer / Managerial) -- BE WorkflowConfigService
					// memakai `step_send_back` dari request; tanpa key ini BE memakai default step.
					...(loadingKey === 'isLoadingSendBack' && this.canChooseSendBackStep && this.modalFooter.sendBackTo && {
						step_send_back: this.modalFooter.sendBackTo.value,
					}),
				};
				const serviceAction = this.modalFooter.action; // 'approve' | 'reject' | 'sendBack'
				await api(this, woApprovalService[serviceAction](payload));
				this.closeModal();
				this.$router.push({ name: 'My Task' });
			} catch (error) {
				this.handleErrorObjectNested(error);
			} finally {
				this[loadingKey] = false;
			}
		},
		
		// Ctx evaluator form engine untuk 1 item cataloguer -- semantik sama dengan buildCtx di useFormConfigEngine
		// (mcr_type uppercase, client/company dari sesi user, field lain dari item). isView false: ini validasi simpan.
		cataloguerConfigCtx(item) {
			return {
				isView: false,
				getField: (name) => {
					if (name === 'mcr_type') return (this.mcrHeader.type || '').toUpperCase();
					if (name === 'mcr_status') return String(this.mcrHeader.status || '').toLowerCase();
					if (name === 'client') return this.clientCode;
					if (name === 'company') return this.companyCode;
					// Context murni FE, sama dengan tab (useFormConfigEngine): role user login & mode form. Save cuma tampil di form
					// yang bisa diedit -> "edit". Dipakai mis. ANTAM: Item Name / Item Type / Characteristic tidak tampil untuk Inventory
					// Control -> tidak divalidasi FE (tetap dikirim & disimpan).
					if (name === 'user_roles') return this.userRoleNames;
					if (name === 'form_mode') return 'edit';
					return item?.[name];
				},
				hasLine: (section) => Array.isArray(item?.[section]) && item[section].length > 0,
				getRows: (section) => (Array.isArray(item?.[section]) ? item[section] : []),
				getFieldOption: () => undefined,
			};
		},
		// Baris field tabel yang ikut payload Save: baris yang semua kolomnya kosong dibuang. Field `rows_from` (mis.
		// cat_emcr_mrps = baris cat_emcr_plants) disaring dengan kolom field SUMBER-nya, supaya index payload tetap sejajar
		// (BE memasangkan per index). Satu sumber untuk payload & validasi -- baris yang tidak dikirim tidak divalidasi.
		payloadTableRows(config, fc, rows) {
			const columns = fc.rows_from ? Object.keys(this.findTableConfig(config, fc.rows_from)?.columns || {}) : Object.keys(fc.columns || {});
			return (Array.isArray(rows) ? rows : []).filter((row) => columns.some((column) => formConfig.isFilledValue(row?.[column])));
		},
		// Aturan FORM02, padanan validateForm() McrItemFormDialog: field wajib 100% dari rules[]/row_rules config
		// (isFieldMandatory/isColumnMandatory sudah termasuk `enabled`, mirror FormConfigRuleBuilder di BE).
		// Bentuk error sama dengan versi lama (validateMcrItemCore) supaya inline error tab New_* & modal tab tetap jalan:
		// - field biasa -> errors[field] = pesan (dibaca hasErrorField di New_BasicDataTab)
		// - kolom tabel -> errors[field][index][column] = pesan + row.rowErrors[column] = true (isColumnInvalidFn)
		// - row_rules   -> errors[field] = pesan kalau jumlah baris < min_rows (atau 0 baris saat `required`)
		validateSingleMcrItem(type) {
			if (!['processed'].includes(type)) return { validation: false, message: 'the MCR is not MCR Processed' };
			const item = this.selectedMcrItem;
			if (!item) return { validation: false, message: 'there is not the selecteed MCR item' };

			const config = this.engineFormConfig;
			const ctx = this.cataloguerConfigCtx(item);
			// Nilai field terkunci (`readonlyandsaved` + default_value) dihitung ulang dulu -- bisa basi kalau Material Type /
			// tabel lain diubah setelah tab-nya terakhir dibuka. Validasi & payload membaca item yang sama.
			formConfig.applyLockedDefaults(config, item, ctx);
			const errors = {};
			const tabErrors = {};
			// Pesan aturan antar-kolom (`row_checks` compare, mis. Safety Stock < Reorder Point) per tab -- ditampilkan di modal
			// menggantikan "Tab X" polos, karena sel yang ditandai merah saja tidak menjelaskan alasannya.
			const compareMessages = {};
			const markTab = (tab) => {
				tabErrors[tab] = CATALOGUER_TAB_LIST.find((t) => t.configKey === tab)?.label || tab;
			};

			// Reset error baris SEKALI untuk semua tabel sebelum validasi -- bukan per field: baris bisa dipakai >1 field
			// (`rows_from`, mis. baris MRP = baris Plant), reset per field akan menghapus error yang baru ditandai field lain.
			// Sekaligus supaya error lama tidak nyangkut kalau tab-nya sekarang tidak visible.
			Object.keys(config?.tab_fields || {}).forEach((tab) => {
				Object.entries(formConfig.getTabFieldMap(config, tab) || {}).forEach(([field, fc]) => {
					if (!fc?.columns && !fc?.row_rules) return;
					(Array.isArray(item[field]) ? item[field] : []).forEach((row) => { if (row && typeof row === 'object') row.rowErrors = {}; });
				});
			});

			Object.keys(config?.tab_fields || {}).forEach((tab) => {
				const fields = formConfig.getTabFieldMap(config, tab) || {};
				const tabVisible = formConfig.isTabVisible(config, tab, ctx);

				Object.entries(fields).forEach(([field, fc]) => {
					// `display_only`: field tampilan saja (mis. PO Text, MCR History) -- tidak divalidasi & tidak dikirim.
					if (!fc || typeof fc !== 'object' || fc.display_only) return;

					if (fc.columns || fc.row_rules) {
						// Baris kosong (mis. baris Accounting yang dibuat otomatis tapi tidak diisi) tidak dikirim -> tidak divalidasi
						// & tidak dihitung. Field tanpa `columns` (file polos) tetap dihitung apa adanya.
						const rows = fc.columns ? this.payloadTableRows(config, fc, item[field]) : (Array.isArray(item[field]) ? item[field] : []);
						if (!tabVisible) return;

						const needed = formConfig.getRequiredRowCount(config, tab, field, ctx);
						if (rows.length < needed) {
							errors[field] = `At least ${needed} row(s) required.`;
							markTab(tab);
						}

						Object.keys(fc.columns || {}).forEach((column) => {
							rows.forEach((row) => {
								const rowCtx = formConfig.withRowCtx(ctx, row);
								if (!formConfig.isColumnVisible(config, tab, field, column, rowCtx)) return;
								if (!formConfig.isColumnMandatory(config, tab, field, column, rowCtx)) return;
								if (formConfig.isFilledValue(row[column])) return;
								row.rowErrors[column] = true;
								// Pesan min_rows (string) didahulukan; selain itu 1 object per baris (tanpa lubang), index = posisi baris
								// di tabel (bukan di daftar baris tersaring) supaya cocok dengan baris yang dirender tab.
								if (typeof errors[field] !== 'string') {
									const all = Array.isArray(item[field]) ? item[field] : [];
									if (!Array.isArray(errors[field])) errors[field] = all.map(() => ({}));
									errors[field][all.indexOf(row)][column] = REQUIRED_MESSAGE;
								}
								markTab(tab);
							});
						});

						// Aturan antar-kolom di baris yang sama (`row_checks` type compare) -- mirror FormConfigRuleBuilder BE.
						rows.forEach((row) => {
							formConfig.evaluateRowCompareChecks(config, tab, field, row, ctx).forEach((failure) => {
								[failure.column, failure.other].filter(Boolean).forEach((column) => { row.rowErrors[column] = true; });
								const all = Array.isArray(item[field]) ? item[field] : [];
								if (typeof errors[field] !== 'string') {
									if (!Array.isArray(errors[field])) errors[field] = all.map(() => ({}));
									errors[field][all.indexOf(row)][failure.column] = failure.message;
								}
								markTab(tab);
								// Koma dipakai showTabValidationModal sebagai pemisah baris.
								(compareMessages[tab] = compareMessages[tab] || new Set())
									.add(`row ${all.indexOf(row) + 1}: ${String(failure.message).replace(/,/g, ' ')}`);
							});
						});
						return;
					}

					if (!tabVisible) return;
					if (!formConfig.isFieldVisible(config, tab, field, ctx)) return;
					if (!formConfig.isFieldMandatory(config, tab, field, ctx)) return;
					if (!formConfig.isFilledValue(item[field])) {
						errors[field] = REQUIRED_MESSAGE;
						markTab(tab);
					}
				});
			});

			const groupingErrorVal = new Set(Object.entries(tabErrors).flatMap(([tab, tabName]) => (compareMessages[tab]
				? [...compareMessages[tab]].map((text) => `Tab ${tabName} ${text}`)
				: [`Tab ${tabName}`])));
			if (groupingErrorVal.size > 0) {
				// Update error hanya untuk slot item yang sedang dipilih
				const itemIndex = this.stateAllMcrItemCat.findIndex((i) => i.id === item.id);
				if (itemIndex !== -1) {
					const currentErrors = this.stateAllMcrItemCat.map(() => ({}));
					currentErrors[itemIndex] = errors;
					this.addValidationErrorAllMcrItemCat({ data: currentErrors });
				}
				return { validation: false, message: Array.from(groupingErrorVal).join(',') };
			}

			this.addValidationErrorAllMcrItemCat({ data: [] });
			return { validation: true, message: '' };
		},
		// Aturan FORM02, padanan buildSaveFormData() McrItemFormDialog: identitas item + HANYA field yang ada di config
		// (bertambah otomatis seiring config & tab New_* bertambah, tanpa ubah method ini).
		// - field biasa -> payload[maps_to ?? field] = item[field] (key = path storage, kontrak BE flattenPayload/Guard/
		//   RuleBuilder). Kalau >1 field maps_to key yang sama (material_number & service_number), yang visible menang.
		// - field tabel -> item[field], tiap baris cuma kolom config; baris yang semua kolomnya kosong (placeholder Add) dibuang
		// - row_rules tanpa kolom (file) -> belum ada di FORM02, belum ditangani
		// Field !visible/!enabled TIDAK di-null-kan di sini -- sama seperti FORM01, itu tugas BE (FormConfigGuard).
		// Config field tabel (punya `columns`) di tab mana pun -- dipakai `rows_from` untuk membaca kolom field sumbernya.
		findTableConfig(config, field) {
			for (const tab of Object.keys(config?.tab_fields || {})) {
				const fc = formConfig.getFieldConfig(config, tab, field);
				if (fc?.columns) return fc;
			}
			return null;
		},
		preparePayloadSingleItem() {
			const item = this.selectedMcrItem;
			if (!item) return null;

			const config = this.engineFormConfig;
			const ctx = this.cataloguerConfigCtx(item);
			const payload = {
				id: item.id ?? null,
				mcr_code: this.mcrHeader.mcr_code || item.mcr_code || null,
				mcr_item_code: item.mcr_item_code ?? null,
				mcr_type: (this.mcrHeader.type || '').toUpperCase(),
				client: item.client || this.clientCode || null,
			};

			Object.keys(config?.tab_fields || {}).forEach((tab) => {
				const fields = formConfig.getTabFieldMap(config, tab) || {};
				Object.entries(fields).forEach(([field, fc]) => {
					// `display_only`: field tampilan saja (mis. PO Text, MCR History) -- tidak divalidasi & tidak dikirim.
					if (!fc || typeof fc !== 'object' || fc.display_only) return;

					if (fc.columns) {
						const columns = Object.keys(fc.columns);
						payload[field] = this.payloadTableRows(config, fc, item[field])
							.map((row) => Object.fromEntries(columns.map((column) => [column, toPayloadValue(row[column])])));
						return;
					}

					if (fc.row_rules) return;
					const key = fc.maps_to || field;
					if (key in payload && !formConfig.isFieldVisible(config, tab, field, ctx)) return;
					payload[key] = toPayloadValue(item[field]);
				});
			});

			return payload;
		},
		async saveCatalog() {
			this.isLoadingSaveDraft = true;
			this.deleteErrorValidationAllMcrItemCat();

			// Validasi dulu sebelum save. Payload disusun SETELAH validasi: validasi menghitung ulang nilai field terkunci
			// (`readonlyandsaved` + default_value) ke item, payload harus membaca nilai terbaru itu.
			let type = "processed";
			const { validation, message } = this.validateSingleMcrItem(type);
			if (!validation) {
				this.showTabValidationModal(message);
				this.isLoadingSaveDraft = false;
				return;
			}

			const payloadCat = this.preparePayloadSingleItem();
			try {
				const response = await api(this, cataloguerFormService.updatePerItem(payloadCat), false);

				const catEmcrPreviewDescriptions = {cat_short_description: response.data.cat_short_description, cat_po_vertical: response.data.cat_po_vertical, cat_po_horizontal: response.data.cat_po_horizontal}
				// Update DI TEMPAT (bukan salinan {...item}): tab New_* memegang objek item yang sama lewat prop mcrItem.
				// Kalau diganti salinan, edit berikutnya di tab masuk ke objek lama sedangkan Save membaca salinan.
				const updatedItem = Object.assign(this.selectedMcrItem, { status: response.data.status, catalogued_by: response.data.catalogued_by, cat_emcr_preview_descriptions: catEmcrPreviewDescriptions, cat_short_description: response.data.cat_short_description, cat_po_vertical: response.data.cat_po_vertical, cat_po_horizontal: response.data.cat_po_horizontal }, this.savedItemLabels(response.data));

				this.commitSavedItem(updatedItem);
				this.$toastNotifPrime('success', 'Success', 'Data saved successfully');
			} catch (error) {
				this.handleErrorObjectNested(error);
			} finally {
				this.isLoadingSaveDraft = false;
			}
		},
		handleErrorObjectNested(error) {
      if (error.response?.data?.code == 400 || error.response?.status == 422 || error.response?.status == 500) {
        const errorData = error.response?.data?.data;

        // Error validasi per baris (bentuk yang sama dengan response import) — tampilkan
        // konsisten lewat showLineValidationErrors, bukan di-loop sebagai object.
        if (Array.isArray(errorData)) {
          this.showLineValidationErrors(errorData, error.response.data.message);
          return;
        }

        if (typeof errorData === 'object' && errorData !== null) {
          const allErrors = [];
          
          for(const key in errorData) {    
            if (Object.prototype.hasOwnProperty.call(errorData, key)) {
              const messages = Array.isArray(errorData[key]) ? errorData[key] : [errorData[key]];
              messages.forEach(message => {
                allErrors.push(`• ${key}: ${message}`);
              });
            } 
          }
          
          if (allErrors.length > 0) {
            const errorMessage = allErrors.join('\n');
            this.$toastNotifPrime('error', error.response.data.message, errorMessage);
            return;
          }
        }
        
        // Fallback for 500 error
        if (error.response?.status == 500) {
          this.$toastNotifPrime('error', 'Error', 'Failed to save MCR');
          return;
        }
        
        // Other errors
        const errorMessage = error.response?.data?.message || error.message || 'An error occurred';
        this.$toastNotifPrime('error', 'Error', errorMessage);
      } else {
        this.$toastNotifPrime('error', 'Error', error.message || 'An unexpected error occurred');
      }
    },
		validateAllTabsCatalogForm(type) {
			if (!['processed'].includes(type)) return { validation: true, message: '' };
			const isThereTabError = [];
			const allErrorValCat = this.stateAllMcrItemCat.map((item, indx) => {
				if (!isThereTabError[indx]) isThereTabError[indx] = {};
				const rules = buildDynamicRulesForItem(item, this.companyCode, this.mcrHeader.type);
				if (!rules) return {};
				const { errors, tabErrors } = validateMcrItemCore(item, rules);
				Object.assign(isThereTabError[indx], tabErrors);
				return errors;
			});
			const groupingErrorVal = new Set();
			isThereTabError.forEach((obj) => {
				if (Object.keys(obj).length > 0) {
					Object.values(obj).forEach((tabName) => groupingErrorVal.add(`Tab ${tabName}`));
				}
			});
			if (groupingErrorVal.size > 0) {
				this.addValidationErrorAllMcrItemCat({ data: allErrorValCat });
				return { validation: false, message: `${Array.from(groupingErrorVal).join(',')}` };
			}
			this.addValidationErrorAllMcrItemCat({ data: [] });
			return { validation: true, message: '' };
		},
		preparePayload(catOrUser) {
			let allFormDataCat = [];
			const normalize = val => {
				if (!val) return val;
				
				// Handle object
				if (typeof val === 'object' && val !== null) {
					if (val.code) return val.code;
					if (val.warehouse_number) return val.warehouse_number;
					if (val.label && typeof val.label === 'string' && val.label.includes(" - ")) {
						return val.label.split(" - ")[0];
					}
					if (val.label) return val.label;
				}
				
				// Handle string - check if there's a detail object first
				// This handles SearchableSelect fields that store label in field and object in field_detail
				if (typeof val === 'string') {
					// Try to find detail object (e.g., item_cat_group_detail for item_cat_group)
					// This is handled by checking the parent context, but we can't access it here
					// So we just return the string as-is and rely on the mapping to use detail objects
					return val;
				}
				
				return val;
			};

			if (catOrUser === 'cataloguer') {
				allFormDataCat = this.stateAllMcrItemCat.map(y => {
					const payloadMnf = y.cat_emcr_item_manufacturer.map(mf => ({
						mpn_number: mf.mpn_number ?? null,
						manufacture: mf.catalog_manufacture?.code || mf.manufacture,
						manufacture_ref: mf.manufacture_ref,
						manufacture_ref_description: mf.manufacture_ref_description,
						source_type: normalize(mf.source_type),
						manref_type: normalize(mf.manref_type),
						position: mf.position ? String(mf.position) : null,
						spn: mf.spn,
						valid_until: mf.valid_until,
						notes: mf.notes
					})); //ada ubah
					const payloadEqp = y.cat_emcr_item_equipment.map(eq => ({
						client: this.clientCode,
						plant: normalize(eq.plant),
						equipment: eq.equipment_detail?.code || eq.equipment,
						qty_installed: String(eq.qty_installed ?? '')
					}));
					const payloadPlant = y.cat_emcr_item_plants.map(pl => ({
						client: this.clientCode,
						plant: normalize(pl.plant),
						period_in: pl.period_in || null,
						unit_of_issue: pl.unit_of_issue || null
					})); //ada ubah
					const payloadKeword = y.cat_emcr_item_keyword.map(kw => ({ keyword: kw.keyword }));
					const payloadLoc = y.cat_emcr_item_location.map(lc => ({
						client: this.clientCode,
						plant: normalize(lc.plant),
						location: lc.location_detail?.code || lc.location,
						bin: lc.bin,
						stock: lc.stock != null ? String(lc.stock) : null
					}));
					const payloadVal = y.cat_emcr_item_valuation.map(vl => ({
						client: this.clientCode,
						valuation_area: normalize(vl.valuation_area),
						valuation_category: normalize(vl.valuation_category),
						valuation_type: normalize(vl.valuation_type),
						price_control: normalize(vl.price_control),
						moving_price: vl.moving_price ? String(vl.moving_price) : null,
						std_price: vl.std_price ? String(vl.std_price) : null,
						price_unit: vl.price_unit ? String(vl.price_unit) : null,
						price_reference: vl.price_reference != null ? String(vl.price_reference) : null,
						valuation_class: normalize(vl.valuation_class),
						ml_active: vl.ml_active,
						ml_settle: vl.ml_settle ? String(vl.ml_settle) : null,
						qty_struct: vl.qty_struct,
						overhead_group: vl.overhead_group ?? '',
						price_determination: vl.price_determination
					})); //ada ubah
					const payloadCharVal = y.cat_emcr_item_characteristic_value.map(cv => ({
						cin_code: cv.cin_code,
						cinv_code: cv.cinv_code ?? null,
						view: cv.view ?? null,
						is_multiple: cv.is_multiple ?? null,
						classification_type: ""
					})); //ada ubah
					const payloadAttach = y.cat_emcr_item_attachment
						.filter(att => att.file_code) // Send all attachments with file_code
						.map(att => ({ file_code: att.file_code}));
					const payloadSales = (y.cat_emcr_item_sales || []).map(sl => ({
						acc_ass_group: normalize(sl.acc_ass_group),
						sales_organization: normalize(sl.sales_organization),
						distr_channel: normalize(sl.distr_channel),
						cash_discount: sl.cash_discount,
						item_cat_code: sl.item_cat_group,
						material_statistic_code: sl.material_statistic_code,
						division: sl.division,
						material_price: sl.material_price,
						client: this.clientCode,
						delivering_plant: sl.delivering_plant,
						sales_unit: sl.sales_unit,
						commission_group: sl.commission_group,
						departure_country: sl.departure_country,
						tax_category: sl.tax_category,
						tax_classification: sl.tax_classification,
						gen_item_cat_grp: sl.gen_item_cat_grp
					})); //ada ubah
					const payloadWarehouses = (y.cat_emcr_item_warehouses || []).map(wh => ({
						warehouse_number: wh.warehouse_number,
						client: this.clientCode,
						plant: wh.plant,
						stock_removal: normalize(wh.stock_removal),
						stock_replacement: normalize(wh.stock_replacement),
						storage_section_ind: normalize(wh.storage_section_ind)
					})); //ada ubah
					const payloadStorageTypes = (y.cat_emcr_item_storage_types || []).map(st => ({
						client: this.clientCode,
						plant: normalize(st.plant),
						warehouse_number: normalize(st.warehouse_number),
						storage_type: normalize(st.storage_type),
						storage_bin: normalize(st.storage_bin)
					})); //ada ubah
					const payloadSalesGenPlants = (y.cat_emcr_item_sale_general_plants || []).map(sgp => ({
						client: this.clientCode,
						plant: sgp.plant,
						trans_grp: sgp.trans_grp,
						batch_management: sgp.batch_management,
						loading_group: sgp.loading_group,
						profit_center: sgp.profit_center
					}));
					const payloadMrps = (y.cat_emcr_item_plant || []).map(pl => ({
						client: this.clientCode,
						plant: normalize(pl.plant),
						sparepart_category: pl.sparepart_category,
						mrp_type: normalize(pl.mrp_type),
						mrp_controller: normalize(pl.mrp_controller),
						mrp_group: pl.mrp_group,
						lot_size: pl.lot_size,
						reorder_point: String(pl.reorder_point ?? ''),
						max_stock: String(pl.max_stock ?? ''),
						abc_indicator: normalize(pl.abc_indicator),
						min_lotsize: String(pl.min_lotsize ?? ''),
						max_lotsize: String(pl.max_lotsize ?? ''),
						rounding_value: String(pl.rounding_value ?? ''),
						fixed_lot: String(pl.fixed_lot ?? ''),
						safety_stock: String(pl.safety_stock ?? ''),
						sloc_for_ep: normalize(pl.sloc_for_ep),
						procurement_type: normalize(pl.procurement_type),
						co_product: pl.co_product,
						avail_check: normalize(pl.avail_check),
						requirement_group: normalize(pl.requirement_group),
						individual_collective: pl.individual_collective,
						special_procurement_type: normalize(pl.special_procurement_type),
						planned_delivery: String(pl.planned_delivery ?? ''),
						in_house_production: String(pl.in_house_production ?? ''),
						gr_processing_time: String(pl.gr_processing_time ?? ''),
						sm_key: normalize(pl.sm_key),
						backflush: pl.backflush,
						strategy_group: pl.strategy_group,
						consumption_mode: pl.consumption_mode,
						consumption_periode_forward: String(pl.consumption_periode_forward ?? ''),
						consumption_periode_backward: String(pl.consumption_periode_backward ?? ''),
						mix_mrp: pl.mix_mrp,
						selection_methode: pl.selection_methode,
						service_level: String(pl.service_level ?? '')
					}));
					const payloadWorkSchedViews = [];
					// const payloadWorkSchedViews = (y.cat_emcr_item_work_schedulling_views || []).map(wsv => ({
					// 	client: this.clientCode,
					// 	plant: normalize(wsv.plant),
					// 	production_supervisor: wsv.production_supervisor,
					// 	production_scheduling_profile: wsv.production_scheduling_profile,
					// 	production_storage_location: wsv.production_storage_location,
					// 	underdelivery_toler_limit: wsv.underdelivery_toler_limit,
					// 	overdelivery_toler_limit: wsv.overdelivery_toler_limit
					// }));
					const payloadPurchasing = (y.cat_emcr_item_purchasings || []).map(pcs => ({
						client: this.clientCode,
						plant: normalize(pcs.plant),
						pur_group: normalize(pcs.pur_group) || "",
						order_unit: pcs.order_unit,
						critical_part: pcs.critical_part,
						automation_po: pcs.automation_po,
						plant_sp: pcs.plant_sp
					}));
					const payloadCostView = (y.cat_emcr_item_costing_views || []).map(cvs => ({
						client: this.clientCode,
						plant: normalize(cvs.plant),
						no_costing: cvs.no_costing,
						variance_key: cvs.variance_key,
						qty_struct: cvs.qty_struct,
						original_material: cvs.original_material,
						overhead_group: cvs.overhead_group,
						costing_lot_size: cvs.costing_lot_size != null ? String(cvs.costing_lot_size) : null
					}));
					const payloadQualManag = (y.cat_emcr_item_inspection || []).map(ins => ({
						client: this.clientCode,
						plant: normalize(ins.plant),
						inspect_with_task_list: ins.inspect_with_task_list,
						inspection_type: ins.inspection_type,
						post_to_qi_stock: ins.post_to_qi_stock,
						automatic_assignment: ins.automatic_assignment,
						inspect_charcs: ins.inspect_charcs,
						inspect_percentage: ins.inspect_percentage != null ? String(ins.inspect_percentage) : null,
						skips_allowed: ins.skips_allowed,
						q_score_procedure: ins.q_score_procedure,
						inspect_type_matl_active: ins.inspect_type_matl_active,
						preferred_insp_type: ins.preferred_insp_type
					}));
					const payloadInsText = (y.cat_emcr_item_inspection_text || []).map(it => ({
						language: it.language,
						inspection_text: it.inspection_text
					}));
					const payloadDataOne = (y.cat_emcr_inalum_datas || []).map(ido => ({
						client: this.clientCode,
						plant: normalize(ido.plant),
						category_item: ido.category_item,
						unspsc_x_reference: ido.unspsc_x_reference,
						mind_id_number: ido.mind_id_number,
						review_date_inalum_data: ido.review_date_inalum_data,
						remark_inalum_data: ido.remark_inalum_data
					}));
					const payloadAltUom = (y.cat_emcr_item_alternative_uom || []).map(alt => ({
						client: this.clientCode,
						alternative_unit_of_measure: alt.alternative_unit_of_measure,
						numerator: alt.numerator,
						denumerator: alt.denumerator,
						source_field: alt.source_field
					}));

					return {
						id: y.id,
						mcr_code: this.mcrHeader.mcr_code,
						mcr_item_code: y.mcr_item_code,
						client: this.clientCode,
						// cat_inc didahulukan: di FORM02 isinya selalu kode & ditulis langsung saat user memilih; catalog_inc
						// cuma label dari BE saat item dimuat (bisa basi setelah user mengganti Item Name).
						cat_inc: (typeof y.cat_inc === 'string' && y.cat_inc.includes(' - ') ? y.cat_inc.split(' - ')[0] : y.cat_inc) || y.catalog_inc?.inc,
						cat_item_type: normalize(y.cat_item_type),
						cat_uom: y.catalog_uom?.code || (typeof y.cat_uom === 'string' && y.cat_uom.includes(' - ') ? y.cat_uom.split(' - ')[0] : y.cat_uom),
						cat_material_type: normalize(y.cat_material_type),
						cat_material_group: normalize(y.cat_material_group),
						cat_old_material_number: y.cat_old_material_number,
						cat_industry_sector: y.cat_industry_sector,
						cat_ext_material_group: y.cat_ext_material_group,
						cat_notes: y.cat_notes,
						cat_short_description: y.cat_short_description,
						cat_po_vertical: y.cat_po_vertical,
						cat_po_horizontal: y.cat_po_horizontal,
						cat_product_hierarchy: y.cat_product_hierarchy,
						cat_standard_description: y.cat_standard_description,
						cat_currency: y.cat_currency,
						cat_price_unit: y.cat_price_unit != null ? String(y.cat_price_unit) : null,
						cat_authorization_group: y.cat_authorization_group,
						cat_net_weight: y.cat_net_weight,
						cat_weight_unit: y.cat_weight_unit,
						cat_expiration_date: y.cat_expiration_date,
						cat_manufacture_part_profile: (Array.isArray(payloadMnf) && payloadMnf.length > 0) ? this.mapHardcodeMcr?.manufacture_part_profile || "" : y.cat_manufacture_part_profile || "",
						cat_purchasing_val_key: y.cat_purchasing_val_key,
						// cat_group_class: normalize(y.cat_group_class),
						// cat_kimap: y.cat_kimap,
						// cat_division: y.cat_division,
						// cat_gen_item_cat_grp: typeof y.cat_gen_item_cat_grp === 'object' ? y.cat_gen_item_cat_grp?.label || y.cat_gen_item_cat_grp?.code : y.cat_gen_item_cat_grp,
						// cat_batch_management: y.cat_batch_management,
						// cat_trans_grp: y.cat_trans_grp,
						cat_emcr_manufacturers: payloadMnf,
						cat_emcr_equipments: payloadEqp,
						cat_emcr_plants: payloadPlant,
						cat_emcr_keywords: payloadKeword,
						cat_emcr_locations: payloadLoc,
						cat_emcr_valuations: payloadVal,
						cat_emcr_characteristic_values: payloadCharVal,
						cat_emcr_attachments: payloadAttach,
						cat_emcr_sales: payloadSales,
						cat_emcr_warehouses: payloadWarehouses,
						cat_emcr_storage_types: payloadStorageTypes,
						cat_emcr_sales_general_plants: payloadSalesGenPlants,
						cat_emcr_mrps: payloadMrps,
						cat_emcr_work_schedulling_views: payloadWorkSchedViews,
						cat_emcr_purchasings: payloadPurchasing,
						cat_emcr_costing_views: payloadCostView,
						cat_emcr_quality_managements: payloadQualManag,
						cat_emcr_inspection_texts: payloadInsText,
						cat_emcr_inalum_datas: payloadDataOne,
						cat_emcr_alternative_uoms: payloadAltUom,
					};
				})
			}

			return allFormDataCat
    },
		
		// Modal "Please complete the following tabs: ..." — dipakai bareng oleh saveCatalog()
		// dan saveDraftPeritemFormUserAntam() supaya tampilannya konsisten.
		showTabValidationModal(message) {
			const tabs = message.split(',').map(tab => tab.trim());
			const tabsList = tabs.map(tab => `
				<div style="
					background: white;
					color: #2d3748;
					padding: 8px 14px;
					margin: 6px 0;
					border-radius: 6px;
					font-weight: 500;
					font-size: 0.85rem;
					border: 1px solid #e2e8f0; box-shadow: 0 1px 3px rgba(0,0,0,0.08);
					display: flex;
					align-items: center;
					gap: 6px;
				">
					<i class="pi pi-exclamation-circle" style="font-size: 0.85rem; color: #dc3545;"></i>
					<span>${tab}</span>
				</div>
			`).join('');
			this.$swal({
				icon: 'error',
				title: '<span style="font-size: 1.2rem; font-weight: 600; color: #2d3748; margin-top: -10px; display: block;">Validation Required</span>',
				html: `
					<div style="text-align: left; padding: 0 10px;">
						<p style="color: #4a5568; margin-bottom: 8px; font-size: 0.85rem;">Please complete the following tabs:</p>
						${tabsList}
					</div>
				`,
				confirmButtonText: '<i class="pi pi-check-circle"></i> Got It!',
				confirmButtonColor: '#667eea',
				padding: '0.5rem 1.5rem 1.5rem',
				backdrop: 'rgba(0,0,0,0.4)',
				customClass: {
					popup: 'swal-modern-popup',
					title: 'swal-modern-title',
					htmlContainer: 'swal-modern-html'
				}
			});
		},
		// Simpan draft ANTAM -- validasi & payload SAMA dengan saveCatalog() (murni config FORM02, aturan draft lewat context
		// `mcr_status`), endpoint update-per-item-draft: status item tidak berubah & PO text tidak di-generate.
		// Label relasi (`catalog_*`) dari response Save: kolom tabel item McrItemsTable membaca label ini, bukan kode yang diubah
		// user di tab. Cuma key yang ada di response yang diambil -- data tab lain di item tidak tersentuh.
		savedItemLabels(data) {
			const keys = ['catalog_inc', 'catalog_uom', 'catalog_material_type', 'catalog_material_group', 'catalog_service_category', 'catalog_service_group'];
			return Object.fromEntries(keys.filter((key) => data && key in data).map((key) => [key, data[key]]));
		},
		// Item hasil Save (objek yang sama dengan store selectedMcrItem) diteruskan ke daftar store supaya tabel item ikut berubah.
		commitSavedItem(updatedItem) {
			const updated = this.stateAllMcrItemCat.map((i) => i.mcr_item_code === updatedItem.mcr_item_code ? updatedItem : i);
			this.storeAllMcrItem(updated);
			this.$store.commit('mcr/setSelectedMcrItem', updatedItem);
		},
		async saveDraftPeritemFormUserAntam() {
			this.deleteErrorValidationAllMcrItemCat();
			this.isLoadingSaveDraftFormUserAntam = true;

			const { validation, message } = this.validateSingleMcrItem('processed');
			if (!validation) {
				this.isLoadingSaveDraftFormUserAntam = false;
				this.showTabValidationModal(message);
				return;
			}

			try {
				if (!this.selectedMcrItem) return;
				const response = await api(this, cataloguerFormService.updatePerItemDraft(this.preparePayloadSingleItem()), false);
				// Nilai field sudah ada di objek item (tab menulis langsung ke situ); yang basi cuma label relasi dari BE yang
				// dibaca kolom tabel item (M Type / M Group / UOM ...) -> diambil dari response, di tempat.
				this.commitSavedItem(Object.assign(this.selectedMcrItem, this.savedItemLabels(response?.data)));
				this.$toastNotifPrime('success', 'Success', 'Draft saved successfully');
			} catch (error) {
				this.handleErrorObjectNested(error);
			} finally {
				this.isLoadingSaveDraftFormUserAntam = false;
			}
		},
	}
}
</script>
<style scoped>
.btn:disabled {
	color: white !important;
}
</style>
	